import axios from "axios";
import { Component } from 'react';
import { Alert, Button, Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { hasPermission } from '../../utils/usePermission';
import CommonDetailsForm from '../CommonAddressPage/CommonDetailsForm';
import CommonLoader from '../loaderComponent/CommonLoader';
import CommonTableModule from './../CommonTable/CommonTableModule';
export default class VendorList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vendors: [],
      loading: true,
      hasError: false,
      errMsg: "",
      showForm: false,
      selectedVendor: null
    };
  }

  async componentDidMount() {
    const token = localStorage.getItem("token");
    if (!token) {
      this.setState({ hasError: true, errMsg: "Unauthorized! Please log in.", loading: false });
      return;
    }
    const headers = { Authorization: `Bearer ${token}` };
    try {
      const response = await axios.get('/vendor', { headers });
      this.setState({ vendors: response.data, loading: false });
    } catch (error) {
      console.error("Error fetching vendors:", error);
      let errorMessage = "Failed to load vendors.";
      if (error.response && error.response.status === 403) {
        errorMessage = "Access Denied! Admin privileges required.";
      }
      this.setState({ hasError: true, errMsg: errorMessage, loading: false });
    }
  }

  handleClick = (id) => {
    this.setState({ loading: true });
    let type = 'v'
    setTimeout(() => {
      const selectedVendor = this.state.vendors.find((vendor) => vendor.id === id);
      this.setState({ selectedVendor, showForm: true, loading: false });
      this.props.history.push(`/vendor-address/${type}/${id}`);
    }, 100);
  }

  handleSubmit = (e) => {
    this.setState({ loading: true });
    e.preventDefault();
    console.log("Updated Customer Data:", this.state.selectedVendor);
    this.setState({ showForm: false, selectedVendor: null, loading: true });
  };

  handleAddVendor = () => {
    this.props.history.push('/vendor-add')
  }

  render() {
    const { showForm, selectedVendor } = this.state;
    if (showForm && selectedVendor) {
      return (
        <CommonDetailsForm
          useType="v"
          data={selectedVendor}
          onClose={() => this.setState({ showForm: false, loading: false })}
        />
      );
    }
    const columns = [
      { key: "id", label: "ID" },
      { key: "name", label: "Name" },
      { key: "gst", label: "GST Number" },
      { key: "phone", label: "Phone" },
      { key: "email", label: "Email" },
      { key: "address", label: "Address" },
      // {
      //   key: "createdAt",
      //   label: "Created Date",
      //   render: (value) => DateTimeFormat(value),
      // },
      {
        key: "status",
        label: "Status",
        render: (value) => {
          const status = value?.toLowerCase();
          const isActive = status === "active";

          const styles = {
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            padding: "4px 12px",
            borderRadius: "20px",
            fontSize: "0.75rem",
            fontWeight: 600,
            textTransform: "uppercase",
            backgroundColor: isActive ? "#E6F4EA" : "#FBEAEA",
            color: isActive ? "#216e39" : "#A94442",
            border: `1px solid ${isActive ? "#B6E2C5" : "#F1B5B5"}`,
            minWidth: "80px",
            textAlign: "center",
          };

          return (
            <span style={styles}>
              {isActive ? <FaCheckCircle /> : <FaTimesCircle />} {value}
            </span>
          );
        },
      },
      // {
      //   key: "status",
      //   label: "Status",
      //   render: (value, record) => (
      //     <div className='address-div'>
      //       <Badge variant={value === "Active" ? "success" : "danger"}>{value.toUpperCase()}</Badge>
      //       {/* <Button variant="primary" size="sm" className='address-btn' onClick={() => this.handleClick(record.id)}>
      //         Address
      //       </Button> */}
      //     </div>
      //   ),
      // },
      {
        key: "action",
        label: "Action",
        render: (value, record) => (
          <div className='address-div'>
            {hasPermission('M5S2B1') && (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`tooltip-edit-${record.id}`}>Add address</Tooltip>}
              >
                <Button variant="outline-info" size="sm" className='address-btn info' onClick={() => this.handleClick(record.id)}>
                  <i className="fa fa-plus-circle"></i>
                </Button>
              </OverlayTrigger>
            )}
            {/* <Button variant="primary" size="sm" className='address-btn' onClick={() => this.handleClick(record.id)}>
              Address
            </Button> */}
          </div>
        ),
      },
    ];


    return (
      <div className="container-fluid pt-4">
        <div className="mx-auto" >

          <CommonLoader isLoading={this.state.loading}>
            {hasPermission('M5S1') && (
              <div className='add-role'>
                <Button variant="primary" className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button" onClick={this.handleAddVendor}> <i className="fa fa-plus-circle"></i> Add Vendor</Button>
              </div>
            )}
            <Card className="mb-4 shadow-sm">

              <Card.Header>
                <strong className="mb-0">Vendor List</strong>
              </Card.Header>
              <Card.Body>
                {this.state.hasError ? (
                  <Alert variant="outline-danger" className="m-3">
                    {this.state.errMsg}
                  </Alert>
                ) : (
                  <CommonTableModule columns={columns} data={this.state.vendors} />
                )}
              </Card.Body>
            </Card>
          </CommonLoader>
        </div>
      </div>
    );
  }
}
